import { useEffect, useState } from 'react';
import Access from "../../Components/Access";
import Navbar from "../../Components/Navbar";
import NavbarAdmin from "../../Components/NavbarAdmin";
import { rescueHtml } from '../../Components/Tools';
import Checked from '../../Img/icon-checked.png';
import axios from 'axios';
import qs from 'qs';
import {NotificationManager} from 'react-notifications';


const EnvoiMailUtilisateurs = (props) =>
{
    const [aff, setAff] = useState(false);
    const [boolID, setBoolID] = useState(true);
    const [boolNom, setBoolNom] = useState(false);
    const [boolPrenom, setBoolPrenom] = useState(false);
    const [boolEmail, setBoolEmail] = useState(false);
    const [boolId_organisme, setBoolId_organisme] = useState(false);
    const [boolRang, setBoolRang] = useState(false);
    const [boolCreated, setBoolCreated] = useState(false);
    const [boolCertified, setBoolCertified] = useState(false);
    const [liste, setListe] = useState([]);
    const [filtre_organisme, setFiltre_organisme] = useState('');
    const [filtre_email, setFiltre_email] = useState('');
    const [filtre_nom, setFiltre_nom] = useState('');
    const [filtre_prenom, setFiltre_prenom] = useState('');
    const [selectedUsers, setSelectedUsers] = useState({});
    const [mailModalVisible, setMailModalVisible] = useState(false);
    const [mailSubject, setMailSubject] = useState('');
    const [mailMessage, setMailMessage] = useState('');
    const [isSendingMail, setIsSendingMail] = useState(false);
    const heightObject = window.innerHeight/1.9;

    const purple = '#6571FE';
    const green = '#59B44A';
    const blue = '#069BD3';

    useEffect(() => {
        if (!props.user) {
            props.getUser();
        }

        axios.post("https://app-slfinance.fr/api/users.php", qs.stringify({'getUsers': true}))
        .then((res) => {
            setListe(res.data);
        })
        .catch((err) => {
            console.warn(err);
        })
    }, [props.user])


    function compareIdAsc(a, b)
    {
        return a.id - b.id;
    }

    function compareIdDes(a, b)
    {
        return b.id - a.id;
    }

    function compareNomAsc(a, b)
    {
        // Convertir en majuscules pour assurer la casse
        const nomA = a.nom?a.nom.toUpperCase():0;
        const nomB = b.nom?b.nom.toUpperCase():0;
    
        if (nomA < nomB) {
            return -1;
        }
        if (nomA > nomB) {
            return 1;
        }
        return 0;
    }

    function compareNomDes(a, b)
    {
        // Convertir en majuscules pour assurer la casse
        const nomA = a.nom?a.nom.toUpperCase():0;
        const nomB = b.nom?b.nom.toUpperCase():0;
    
        if (nomA > nomB) {
            return -1;
        }
        if (nomA < nomB) {
            return 1;
        }
        return 0;
    }

    function comparePrenomAsc(a, b)
    {
        // Convertir en majuscules pour assurer la casse
        const prenomA = a.prenom?a.prenom.toUpperCase():0;
        const prenomB = b.prenom?b.prenom.toUpperCase():0;
    
        if (prenomA < prenomB) {
            return -1;
        }
        if (prenomA > prenomB) {
            return 1;
        }
        return 0;
    }

    function comparePrenomDes(a, b)
    {
        // Convertir en majuscules pour assurer la casse
        const prenomA = a.prenom?a.prenom.toUpperCase():0;
        const prenomB = b.prenom?b.prenom.toUpperCase():0;
    
        if (prenomA > prenomB) {
            return -1;
        }
        if (prenomA < prenomB) {
            return 1;
        }
        return 0;
    }

    function compareEmailAsc(a, b)
    {
        // Convertir en majuscules pour assurer la casse
        const emailA = a.email?a.email.toUpperCase():0;
        const emailB = b.email?b.email.toUpperCase():0;
    
        if (emailA < emailB) {
            return -1;
        }
        if (emailA > emailB) {
            return 1;
        }
        return 0;
    }

    function compareEmailDes(a, b)
    {
        // Convertir en majuscules pour assurer la casse
        const emailA = a.email?a.email.toUpperCase():0;
        const emailB = b.email?b.email.toUpperCase():0;
    
        if (emailA > emailB) {
            return -1;
        }
        if (emailA < emailB) {
            return 1;
        }
        return 0;
    }

    function compareId_organismeAsc(a, b)
    {
        return a.id_organisme - b.id_organisme;
    }

    function compareId_organismeDes(a, b)
    {
        return b.id_organisme - a.id_organisme;
    }

    function compareRangAsc(a, b)
    {
        return a.id_type_users - b.id_type_users;
    }

    function compareRangDes(a, b)
    {
        return b.id_type_users - a.id_type_users;
    }

    function compareCreatedAsc(a, b)
    {
        const dateA = new Date(a.created);
        const dateB = new Date(b.created);
        return dateA - dateB;
    }

    function compareCreatedDes(a, b)
    {
        const dateA = new Date(a.created);
        const dateB = new Date(b.created);
        return dateB - dateA;
    }

    function compareCertifiedAsc(a, b)
    {
        if (a.token && !b.token) {
            return 1;
        }
        if (!a.token && b.token) {
            return -1;
        }
        return 0;
    }

    function compareCertifiedDes(a, b)
    {
        if (a.token && !b.token) {
            return -1;
        }
        if (!a.token && b.token) {
            return 1;
        }
        return 0;
    }

    function getListeFiltered()
    {
        return liste.filter(user =>
            (filtre_organisme === '' || (user.organisme_nom && user.organisme_nom.toLowerCase().includes(filtre_organisme))) &&
            (filtre_email === '' || (user.email && user.email.toLowerCase().includes(filtre_email))) &&
            (filtre_nom === '' || (user.nom && user.nom.toLowerCase().includes(filtre_nom))) &&
            (filtre_prenom === '' || (user.prenom && user.prenom.toLowerCase().includes(filtre_prenom)))
        );
    }

    const getRangLabel = (id_type_users) => {
        if (id_type_users === '1') return 'SL';
        if (id_type_users === '2') return 'Admin';
        if (id_type_users === '3') return 'User';
        return '.';
    };

    function toggleUserSelection(userId)
    {
        setSelectedUsers((prev) => ({
            ...prev,
            [userId]: !prev[userId]
        }));
    }

    function isUserSelected(userId)
    {
        return !!selectedUsers[userId];
    }

    function toggleAllFilteredUsers(checked)
    {
        const filtered = getListeFiltered();
        setSelectedUsers((prev) => {
            const next = {...prev};
            filtered.forEach((user) => {
                next[user.id] = checked;
            });
            return next;
        });
    }

    function openMailModal()
    {
        const selectedCount = liste.filter((user) => selectedUsers[user.id]).length;
        if (selectedCount === 0) {
            NotificationManager.warning('Aucun utilisateur selectionne', '', 3000);
            return;
        }
        setMailModalVisible(true);
    }

    function sendMailToSelection()
    {
        const selectedEmails = Array.from(new Set(
            liste
            .filter((user) => selectedUsers[user.id] && user.email)
            .map((user) => rescueHtml(user.email).trim())
            .filter((email) => email !== '')
        ));

        if (selectedEmails.length === 0) {
            NotificationManager.warning('Aucun email valide dans la selection', '', 3000);
            return;
        }

        if (!mailSubject.trim()) {
            NotificationManager.warning('Veuillez renseigner un objet', '', 3000);
            return;
        }

        if (!mailMessage.trim()) {
            NotificationManager.warning('Veuillez renseigner un message', '', 3000);
            return;
        }

        setIsSendingMail(true);

        const params = {
            'sendMailToUsers': true,
            'emails': JSON.stringify(selectedEmails),
            'subject': mailSubject,
            'message': mailMessage,
        };

        axios.post('https://app-slfinance.fr/api/mail_utilisateurs.php', qs.stringify(params))
        .then((res) => {
            if (res.data && res.data.status === 1) {
                NotificationManager.success(res.data.status_message || 'Emails envoyes', '', 3000);
                setMailModalVisible(false);
                setMailSubject('');
                setMailMessage('');
                setSelectedUsers({});
            }
            else {
                NotificationManager.error(res.data?.status_message || 'Erreur lors de l envoi des mails', '', 3000);
            }
        })
        .catch((err) => {
            console.warn(err);
            NotificationManager.error('Erreur lors de l envoi des mails', '', 3000);
        })
        .finally(() => {
            setIsSendingMail(false);
        });
    }


    const filteredList = getListeFiltered();
    const selectedCount = liste.filter((user) => selectedUsers[user.id]).length;
    const selectedFilteredCount = filteredList.filter((user) => selectedUsers[user.id]).length;
    const allFilteredSelected = filteredList.length > 0 && selectedFilteredCount === filteredList.length;
    

	return (
        <Access needConnection={true} type_user={[1]}>
            <Navbar />
            <NavbarAdmin />

            <div style={{display: 'flex', margin: 25, alignItems: 'center', gap: 10, flexWrap: 'wrap'}}>
                <div style={{display: 'flex', alignItems: 'center', gap: 5}}>
                    <p>Paramètre \</p>
                    <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Utilisateurs</p>
                </div>
                <div style={{display: 'flex', flex: 1, justifyContent: 'flex-end', alignItems: 'center', gap: 10}}>
                    <p>{selectedCount} utilisateur(s) selectionne(s)</p>
                    <button
                        onClick={openMailModal}
                        style={{padding: '8px 16px', backgroundColor: purple, color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px'}}
                    >
                        Envoyer un mail a cette liste d utilisateur
                    </button>
                </div>
                <div style={{display: 'flex', width: '100%', marginTop: 5, alignItems: 'center', gap: 10}}>
                    <input 
                        className='shadow-md' 
                        type='text' 
                        placeholder='Filtrer par organisme' 
                        style={{padding: 5, width: 200}} 
                        value={filtre_organisme}
                        onChange={(e) => {setFiltre_organisme(e.target.value.toLowerCase())}}
                    />
                    <input 
                        className='shadow-md' 
                        type='text' 
                        placeholder='Filtrer par email' 
                        style={{padding: 5, width: 200}} 
                        value={filtre_email}
                        onChange={(e) => {setFiltre_email(e.target.value.toLowerCase())}}
                    />
                    <input 
                        className='shadow-md' 
                        type='text' 
                        placeholder='Filtrer par nom' 
                        style={{padding: 5, width: 200}} 
                        value={filtre_nom}
                        onChange={(e) => {setFiltre_nom(e.target.value.toLowerCase())}}
                    />
                    <input 
                        className='shadow-md' 
                        type='text' 
                        placeholder='Filtrer par prenom' 
                        style={{padding: 5, width: 200}} 
                        value={filtre_prenom}
                        onChange={(e) => {setFiltre_prenom(e.target.value.toLowerCase())}}
                    />
                </div>
                <div style={{display: 'flex', width: '100%', alignItems: 'center', gap: 10, marginTop: 5}}>
                    <button
                    className='shadow-md'
                    onClick={() => {
                        toggleAllFilteredUsers(true);
                    }}
                    style={{padding: '6px 10px', borderRadius: 4, backgroundColor: '#EEF2FF', color: '#2F3AA0'}}>
                        Tout selectionner (filtre)
                    </button>
                    <button
                    className='shadow-md'
                    onClick={() => {
                        toggleAllFilteredUsers(false);
                    }}
                    style={{padding: '6px 10px', borderRadius: 4, backgroundColor: '#F5F5F5'}}>
                        Tout deselectionner (filtre)
                    </button>
                    <p style={{fontSize: 13, opacity: 0.85}}>{selectedFilteredCount} selectionne(s) sur {filteredList.length} visible(s)</p>
                </div>
            </div>


            <div className='shadow-md rounded-md' style={{margin: 50}}>
                <div style={{overflowY: 'scroll'}}>
                    <div style={{display: 'flex', backgroundColor: blue, borderTopLeftRadius: 5, borderTopRightRadius: 5, color: 'white'}}>
                        
                        <button
                        onClick={() => {
                            toggleAllFilteredUsers(!allFilteredSelected);
                        }}
                        style={{flex: 0.1, alignItems: 'center', justifyContent: 'center', display: 'flex'}}>
                            <input
                            type='checkbox'
                            checked={allFilteredSelected}
                            readOnly
                            />
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolID) {
                                await liste.sort(compareIdDes);
                            }
                            else {
                                await liste.sort(compareIdAsc);
                            }
                            await setBoolID(!boolID);
                            await setAff(!aff);

                        }}
                        style={{flex: 0.2, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Id</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolNom) {
                                await liste.sort(compareNomDes);
                            }
                            else {
                                await liste.sort(compareNomAsc);
                            }
                            await setBoolNom(!boolNom);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.5, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Nom</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolPrenom) {
                                await liste.sort(comparePrenomDes);
                            }
                            else {
                                await liste.sort(comparePrenomAsc);
                            }
                            await setBoolPrenom(!boolPrenom);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.5, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Prenom</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolEmail) {
                                await liste.sort(compareEmailDes);
                            }
                            else {
                                await liste.sort(compareEmailAsc);
                            }
                            await setBoolEmail(!boolEmail);
                            await setAff(!aff);
                        }}
                        style={{flex: 1, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Email</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolId_organisme) {
                                await liste.sort(compareId_organismeDes);
                            }
                            else {
                                await liste.sort(compareId_organismeAsc);
                            }
                            await setBoolId_organisme(!boolId_organisme);
                            await setAff(!aff);
                        }}
                        style={{flex: 1, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Id organisme</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolRang) {
                                await liste.sort(compareRangDes);
                            }
                            else {
                                await liste.sort(compareRangAsc);
                            }
                            await setBoolRang(!boolRang);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.2, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Rang</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolCreated) {
                                await liste.sort(compareCreatedDes);
                            }
                            else {
                                await liste.sort(compareCreatedAsc);
                            }
                            await setBoolCreated(!boolCreated);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.4, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Créé le</p>
                        </button>
                        
                        <button
                        onClick={async () => {
                            if (boolCertified) {
                                await liste.sort(compareCertifiedDes);
                            }
                            else {
                                await liste.sort(compareCertifiedAsc);
                            }
                            await setBoolCertified(!boolCertified);
                            await setAff(!aff);
                        }}
                        style={{flex: 0.2, alignItems: 'center', justifyContent: 'center', display: 'flex', borderLeft: '1px solid white'}}>
                            <p>Certifié</p>
                        </button>
                    
                    </div>
                </div>

                <div style={{overflowY: 'scroll', maxHeight: heightObject}}>
                    {filteredList.map((user, i) =>
                    <div key={i} style={{display: 'flex'}}>
                        <div
                        onClick={() => {
                            toggleUserSelection(user.id);
                        }}
                        style={{
                            flex: 1,
                            display: 'flex',
                            borderBottom: '1px solid '+blue,
                            backgroundColor: isUserSelected(user.id) ? '#F2F5FF' : 'white',
                            cursor: 'pointer'
                        }}>
                            <div style={{display: 'flex', flex: 0.1, justifyContent: 'center', alignItems: 'center'}}>
                                <input
                                type='checkbox'
                                checked={isUserSelected(user.id)}
                                onChange={(e) => {
                                    e.stopPropagation();
                                    toggleUserSelection(user.id);
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                />
                                <div style={user.session_token?{display: 'flex', width: 15, height: 15, backgroundColor: green, borderRadius: '50%', margin: 4}:{display: 'flex', width: 15, height: 15, border: '1px solid '+blue, borderRadius: '50%', margin: 4}}>
                                </div>
                            </div>
                            <div style={{flex: 0.2, textAlign: 'center', borderLeft: '1px solid '+blue}}>
                                <p>{user.id}</p>
                            </div>
                            <div style={{display: 'flex', flex: 0.5, borderLeft: '1px solid '+blue, overflowX: 'hidden'}}>
                                <p style={{marginLeft: 5}}>{user.nom?rescueHtml(user.nom):'.'}</p>
                            </div>
                            <div style={{display: 'flex', flex: 0.5, borderLeft: '1px solid '+blue, overflowX: 'hidden'}}>
                                <p style={{marginLeft: 5}}>{user.prenom?rescueHtml(user.prenom):'.'}</p>
                            </div>
                            <div style={{display: 'flex', flex: 1, borderLeft: '1px solid '+blue, overflowX: 'hidden'}}>
                                <p style={{marginLeft: 5}}>{user.email?rescueHtml(user.email):'.'}</p>
                            </div>
                            <div style={{display: 'flex', flex: 1, borderLeft: '1px solid '+blue, overflowX: 'hidden'}}>
                                <p style={{marginLeft: 5}}>[ {user.id_organisme} ] {user.organisme_nom?rescueHtml(user.organisme_nom):'.'}</p>
                            </div>
                            <div style={{flex: 0.2, borderLeft: '1px solid '+blue, textAlign: 'center', overflowX: 'hidden'}}>
                                <p>{user.id_type_users === '1'?'SL':user.id_type_users === '2'?'Admin':user.id_type_users === '3'?'User':'.'}</p>
                            </div>
                            <div style={{flex: 0.4, borderLeft: '1px solid '+blue, borderRight: '1px solid '+blue, textAlign: 'center', overflowX: 'hidden'}}>
                                <p>{user.created?user.created.split('-')[2]+'/'+user.created.split('-')[1]+'/'+user.created.split('-')[0]:'.'}</p>
                            </div>
                            <div style={{flex: 0.2, borderRight: '1px solid '+blue, textAlign: 'center'}}>
                                {user.token?'.':
                                <div style={{display: 'flex'}}>
                                    <div style={{flex: 1}}></div>
                                    <img style={{width: 15, margin: 5}} src={Checked} alt='checked' />
                                    <div style={{flex: 1}}></div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    )}

                </div>

            </div>

            {mailModalVisible ? (
            <div style={{position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.35)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999}}>
                <div className='shadow-md' style={{backgroundColor: '#fff', borderRadius: 10, width: 'min(760px, 95vw)', maxWidth: 760, padding: 0, overflow: 'hidden'}}>
                    {/* Header */}
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 18px', backgroundColor: purple, color: 'white'}}>
                        <div style={{fontWeight: '700'}}>
                            Envoyer un mail — {selectedCount} destinataire(s)
                        </div>
                        <button onClick={() => { if (!isSendingMail) setMailModalVisible(false); }} style={{background: 'transparent', border: 'none', color: 'white', fontSize: 18, cursor: 'pointer'}}>✕</button>
                    </div>

                    {/* Body */}
                    <div style={{padding: 18, display: 'flex', flexDirection: 'column', gap: 12}}>
                        <input
                            type='text'
                            placeholder='Objet'
                            value={mailSubject}
                            onChange={(e) => setMailSubject(e.target.value)}
                            style={{padding: 12, borderRadius: 8, border: '1px solid #E6E9F0', width: '100%', boxSizing: 'border-box'}}
                        />

                        <textarea
                            placeholder='Message'
                            value={mailMessage}
                            onChange={(e) => setMailMessage(e.target.value)}
                            style={{padding: 12, borderRadius: 8, border: '1px solid #E6E9F0', width: '100%', minHeight: 220, resize: 'vertical', boxSizing: 'border-box'}}
                        />

                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 6}}>
                            <div style={{fontSize: 13, color: '#6B7280'}}>Expéditeur: postmaster@strategies-locales.fr</div>
                            <div style={{fontSize: 13, color: '#6B7280'}}>{mailMessage.length} caractères</div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div style={{display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '12px 18px', borderTop: '1px solid #F3F4F6', backgroundColor: '#FAFBFF'}}>
                        <button
                            onClick={() => { if (!isSendingMail) setMailModalVisible(false); }}
                            style={{padding: '8px 14px', borderRadius: 8, backgroundColor: '#F3F4F6', border: '1px solid #E5E7EB', cursor: 'pointer'}}
                        >
                            Annuler
                        </button>
                        <button
                            onClick={sendMailToSelection}
                            disabled={isSendingMail}
                            style={{padding: '8px 16px', borderRadius: 8, backgroundColor: purple, color: 'white', border: 'none', cursor: isSendingMail ? 'default' : 'pointer', fontWeight: 600}}
                        >
                            {isSendingMail ? 'Envoi en cours...' : 'Envoyer'}
                        </button>
                    </div>
                </div>
            </div>
            ) : null}

        </Access>
	);
}


export default EnvoiMailUtilisateurs;
